import React from 'react';
import { useState } from 'react';
import { FaBars, FaTimes } from 'react-icons/fa';
import { Link } from 'react-scroll';


const Navbar = () => {

    const [toggle, setToggle] = useState(false)
    const handleToggle = () => {
        setToggle(!toggle)
    }





    return (
        <nav className='bg-[#111111] fixed text-[#999999] font-semibold  flex justify-center items-center w-full h-[80px] z-10'>

            {/* Desktop Menu */}
            <section >
                <ul className="hidden md:flex md:gap-3">
                    <li><Link to="hero"  smooth={true} duration={500} className="hover:border-b-2 border-teal-500" >Home</Link></li>
                    <li><Link to="skill"  smooth={true} duration={500} className="hover:border-b-2 border-teal-500">Skills</Link></li>
                    <li><Link to="project" smooth={true} duration={500} className="hover:border-b-2 border-teal-500">Projects</Link></li>
                    <li><Link to="contact" smooth={true} duration={500} className="hover:border-b-2 border-teal-500">Contact</Link></li>
                </ul>
            </section>

            {/* Hamburger */}
            <section onClick={handleToggle} className="md:hidden flex justify-end items-center cursor-pointer absolute right-10 z-10">
                {!toggle ? <FaBars /> : <FaTimes />}
            </section>

            {/* Mobile Menu */}
            <section className={toggle ? `flex flex-col justify-center items-center text-2xl h-screen bg-[#111111] absolute w-full top-0 left-0` : `hidden`}>
                <ul>
                    <li><Link onClick={handleToggle} to="hero" smooth={true} duration={500} className="hover:border-b-2 border-teal-500" >Home</Link></li>
                    <li><Link onClick={handleToggle} to="skill" smooth={true} duration={500} className="hover:border-b-2 border-teal-500" >Skills</Link></li>
                    <li><li><Link onClick={handleToggle} to="project" smooth={true} duration={500} className="hover:border-b-2 border-teal-500" >Projects</Link></li></li>
                    <li><li><Link onClick={handleToggle} to="contact" smooth={true} duration={500} className="hover:border-b-2 border-teal-500" >Contact</Link></li></li>
                </ul>
            </section>
        </nav>
    );
};

export default Navbar;